(function ($) {
  $('.block--download').each(function () {
    var that = $(this);
    var carousel = that.find(".swiper-container");
    var slidesCount = carousel.find(".swiper-slide").length;

    var mySwiper = new Swiper(carousel[0], {
      watchOverflow: true,
      spaceBetween: 0,
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      // autoplay: {
      //   delay: 5000,
      // },
      navigation: {
        nextEl: that.find('.custom-button-next')[0],
        prevEl: that.find('.custom-button-prev')[0],
      },
      on: {
        init: function (swiper) {
          var text = $(swiper.slides[swiper.realIndex]).find("figcaption").text();
          $(".block--download .cta .btn span").text(text);
          $(".block--download .cta .btn").attr("data-modelevoiture", $.trim(text).replace(/ /g, "+"));
        },
        click: function (swiper, event) {
          swiper.slideTo(swiper.clickedIndex);
        },
      }
    });

    mySwiper.on('slideChange', function (swiper) {
      var text = $(swiper.slides[swiper.realIndex]).find("figcaption").text();
      $(".block--download .cta .btn span").text(text);
      $(".block--download .cta .btn").attr("data-modelevoiture", $.trim(text).replace(/ /g, "+"));
    });
  });
})(jQuery);
